export default __webpack_public_path__ + "static/media/no-records.61bca120.svg";